import { useHotkeys } from 'react-hotkeys-hook';
import { VerifyMatchDialogNavigationState } from './verify-match-types';

/**
 * True when the event originated from a media player that should keep
 * its own key bindings (form fields are excluded via enableOnFormTags).
 */
export function shouldIgnoreVerifyMatchHotkey(event: KeyboardEvent): boolean {
  const eventTarget = event.target;
  if (!(eventTarget instanceof HTMLElement)) {
    return false;
  }

  const tag = eventTarget.tagName;
  if (tag === 'VIDEO' || tag === 'AUDIO') {
    return true;
  }

  return eventTarget.closest('.video-js') != null;
}

/**
 * ArrowLeft / ArrowRight walk the matches list while the verify-match dialog is open.
 */
export function useVerifyMatchDialogKeyboard(
  enabled: boolean,
  navigation: VerifyMatchDialogNavigationState | undefined,
) {
  const hasPrev = !!navigation?.hasPrev;
  const hasNext = !!navigation?.hasNext;
  const onPrev = navigation?.onPrev;
  const onNext = navigation?.onNext;

  useHotkeys(
    'arrowleft',
    () => {
      onPrev?.();
    },
    {
      enabled: enabled && hasPrev && !!onPrev,
      enableOnFormTags: false,
      preventDefault: true,
      ignoreEventWhen: shouldIgnoreVerifyMatchHotkey,
    },
    [enabled, hasPrev, onPrev],
  );

  useHotkeys(
    'arrowright',
    () => {
      onNext?.();
    },
    {
      enabled: enabled && hasNext && !!onNext,
      enableOnFormTags: false,
      preventDefault: true,
      ignoreEventWhen: shouldIgnoreVerifyMatchHotkey,
    },
    [enabled, hasNext, onNext],
  );
}
